import React from 'react';

import Comment from './Comment.jsx';

function Wrapper(props) {
    const style = props.style ? { ...props.style } : {};
    style.minWidth = '100%';
    const width = props.maxWidth || 600;

    let content = props.children;
    if (props.isLayout != true) {
        content = (
            <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                className={props.className}
                style={{ minWidth: '100%' }}
                width="100%">
                <tbody className={`${props.className}Outer`}>
                    <tr>
                        {content}
                    </tr>
                </tbody>
            </table>
        );
    }
    const containerStyle = props.containerStyle ? { ...props.containerStyle } : {};
    containerStyle.maxWidth = `${width}px`;
    return (
        <table border="0" cellPadding="0" cellSpacing="0" style={{ backgroundColor: style.backgroundColor, minWidth: '100%' }} width="100%">
            <tbody style={{ backgroundColor: style.backgroundColor }}>
                <tr>
                    <td align="center" data-template-container style={style} valign="top">
                        {
                            props.renderMso &&
                            <Comment document={props.frameDoc} id={`${props.blockId}-top`} value={`<!--[if (gte mso 9)|(IE)]><table align="center" border="0" cellspacing="0" cellpadding="0" width="${width}" style="width:${width}px;"><tr><td align="center" valign="top" width="${width}" style="width:${width}px;"><![endif]-->`} />
                        }
                        <table
                            align="center"
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            className="templateContainer" // Might not need this in favor of inline style?
                            style={containerStyle}
                            width="100%">
                            <tbody>
                                <tr>
                                    <td valign="top">
                                        {content}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {
                            props.renderMso &&
                            <Comment document={props.frameDoc} id={`${props.blockId}-bottom`} value={`<!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->`} />
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export { Wrapper }